import partition from "lodash/partition";

export default function () {
    const docs = document.getElementById('docs-section');

    if (!docs) return;


    const toc_links = [...document.getElementsByClassName('toc-link')];


    const observer = new IntersectionObserver(observed_entries => {
        observed_entries.forEach(observed_entry => {
            const title = observed_entry.target;


            const href = title.dataset.href;

            const toc_link = document.getElementById('#'+href+'-toc-link');

            if(observed_entry.isIntersecting){
                toc_link.classList.add('!text-theme-500');
            }else{
                toc_link.classList.remove('!text-theme-500');
            }

        })
    })

    toc_links.forEach(toc_link => {
            const anchor = document.querySelector(toc_link.getAttribute('href'));

            const title = anchor.parentElement;

            title.dataset.href = anchor.id;
            title.style.scrollMargin = '20px';

            observer.observe(title);

            toc_link.addEventListener('click', e => {
                e.preventDefault();
                title.scrollIntoView({ behavior: 'smooth' });
            })
    })
}

